<template>
  <div class="bg-white dark:bg-gray-800 sticky -top-6">
    <div class="border-b border-gray-300 dark:border-gray-700">
      <div class="h-16 flex items-center px-6 gap-2">
        <at-skeleton class="w-full" />
      </div>
    </div>

    <div class="h-12 px-6 py-4 flex items-center gap-4 border-b border-gray-300 dark:border-gray-700">
      <at-skeleton class="w-32" />
      <at-skeleton class="w-32" />
      <at-skeleton class="w-32" />
    </div>
  </div>
</template>

<script setup>
  import { AtSkeleton } from '@packages/aliftech-ui';
</script>
